import React from 'react';
import { color } from '../tokens';
import IconButton from './IconButton';

interface StepperProps {
  step: number;
  total: number;
  onBack?: () => void;
}

const rowStyle: React.CSSProperties = { display: 'flex', alignItems: 'center', gap: 12, marginBottom: 18 };
const spacer: React.CSSProperties = { width: 44, height: 44 };
const counterStyle: React.CSSProperties = { fontSize: 13, fontWeight: 600, color: color.textMuted };
const dotsWrap: React.CSSProperties = { display: 'flex', gap: 6, marginLeft: 'auto' };

function dotStyle(filled: boolean): React.CSSProperties {
  return { width: 8, height: 8, borderRadius: 999, background: filled ? color.accent : color.border };
}

/** «Шаг N из M» header with an optional back affordance. */
export function Stepper({ step, total, onBack }: StepperProps) {
  return (
    <div style={rowStyle}>
      {onBack ? (
        <IconButton label="Назад" onClick={onBack}>←</IconButton>
      ) : (
        <span style={spacer} />
      )}
      <div style={counterStyle}>Шаг {step} из {total}</div>
      <div style={dotsWrap}>
        {Array.from({ length: total }).map((_, i) => (
          <span key={i} style={dotStyle(i < step)} />
        ))}
      </div>
    </div>
  );
}

interface WizardStepProps {
  step: number;
  total: number;
  question: string;
  onBack?: () => void;
  children: React.ReactNode;
  footer?: React.ReactNode;
}

const frame: React.CSSProperties = { padding: '20px 20px 24px', boxSizing: 'border-box' };
const questionStyle: React.CSSProperties = { margin: '0 0 18px', fontSize: 22, fontWeight: 700, lineHeight: 1.25, color: color.text };
const footerStyle: React.CSSProperties = { marginTop: 24 };

/**
 * One-question-per-screen wizard frame. Used by the clarification flow so the
 * user answers a single simple question at a time (no 16-field forms).
 */
export default function WizardStep({ step, total, question, onBack, children, footer }: WizardStepProps) {
  return (
    <div style={frame}>
      <Stepper step={step} total={total} onBack={onBack} />
      <h2 style={questionStyle}>{question}</h2>
      <div>{children}</div>
      {footer ? <div style={footerStyle}>{footer}</div> : null}
    </div>
  );
}
